import { ModuleConfig } from '@/core/module';
import { transactionMenuRoutes } from './routes';
import { useTransactionMenuStore } from './stores/transaction-menu-store';

// Export hooks
export { useTransactionMenus } from './hooks/useTransactionMenus';

// Export components
export { TransactionMenuForm } from './components/TransactionMenuForm';
export { TransactionMenuTable } from './components/TransactionMenuTable';

// Export views
export { TransactionMenuListView } from './views/TransactionMenuListView';

// Export types
export * from './types';

export const TransactionMenuModule: ModuleConfig = {
    name: 'transaction-menu',
    routes: transactionMenuRoutes,
    stores: {
        transactionMenu: useTransactionMenuStore
    },
    initialize: () => {
        console.log('Transaction Menu module initialized');
    }
};
